export const htmlToMetaDescription = (text: string, limit: number): string => {
  if (!text) {
    return text;
  }
  const clean = text.replace(/<(?:.|\n)*?>/gm, '');

  return clean.length > limit ? clean.substring(0, limit) + '...' : clean;
};
